function buildUrlWithRoute(baseUrl: string | undefined, routeSegments: string[]): string {
  const normalizedBaseUrl = baseUrl ?? '';
  const queryOrFragmentIndex = normalizedBaseUrl.search(/[?#]/);
  const basePath = (queryOrFragmentIndex === -1
    ? normalizedBaseUrl
    : normalizedBaseUrl.slice(0, queryOrFragmentIndex)
  ).replace(/\/$/, '');
  const suffix = queryOrFragmentIndex === -1
    ? ''
    : normalizedBaseUrl.slice(queryOrFragmentIndex);

  return `${basePath}/${routeSegments.join('/')}${suffix}`;
}

export function buildDocQrRouteUrl(
  baseUrl: string | undefined,
  werkmaatschappij: string,
  projectcode: string,
  documentnummer: string,
  revisie: string,
  revisiedatum: string
): string {
  const routeSegments = [werkmaatschappij, projectcode, documentnummer, revisie, revisiedatum]
    .map(encodeURIComponent);

  return buildUrlWithRoute(baseUrl, routeSegments);
}

export function buildDocQrResultUrl(
  baseUrl: string | undefined,
  werkmaatschappij: string,
  projectcode: string,
  documentnummer: string,
  revisie: string,
  revisiedatum: string
): string {
  return buildUrlWithRoute(baseUrl, [
    'api',
    'docqr',
    werkmaatschappij,
    projectcode,
    documentnummer,
    revisie,
    revisiedatum
  ].map(encodeURIComponent));
}
